
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.671 9.426L20 5l10.328 4.426a2.208 2.208 0 011.338 2.03v9.188a13.25 13.25 0 01-6.676 11.504L20 35l-4.99-2.852a13.25 13.25 0 01-6.677-11.504v-9.188c0-.883.526-1.682 1.338-2.03z","stroke":"#1D1D1D","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.564 16.29l-7.419 7.42-3.71-3.71","stroke":"#1D1D1D","stroke-width":"1.5","stroke-linecap":"square","stroke-linejoin":"round"}})])
          )
        }
      }
    